qw-guest {
  --qw-guest-width: 60%;

  display: flex;
  flex-direction: column;
  width: var(--qw-guest-width);
}

qw-guest.qw-guest--center {
  margin: 0 auto;
}

qw-guest.qw-guest--disabled {
  opacity: var(--qw-hotel-opacity);
  pointer-events: none !important;
}

qw-guest .qw-guest__counter-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

qw-guest .qw-guest__counter-wrapper__label {
  margin-right: var(--qw-hotel-gap-md);
}
